import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export type SalesforceStageKey =
	| 'Won'
	| 'Lost (Closed)'
	| 'Lost (Send survey)'
	| 'Invalid opportunity';

export const i18n: Record<SalesforceStageKey, MessageDescriptor> =
	defineMessages<SalesforceStageKey>({
		Won: {
			id: 'search-page.salesforce.filter.stage.won',
			defaultMessage: 'Won',
			description: 'Won stage for a Salesforce opportunity',
		},
		'Lost (Closed)': {
			id: 'search-page.salesforce.filter.stage.lost-closed',
			defaultMessage: 'Lost (Closed)',
			description: 'Lost (Closed) stage for a Salesforce opportunity',
		},
		'Lost (Send survey)': {
			id: 'search-page.salesforce.filter.stage.lost-send-survey',
			defaultMessage: 'Lost (Send survey)',
			description: 'Lost (Send survey) stage for a Salesforce opportunity',
		},
		'Invalid opportunity': {
			id: 'search-page.salesforce.filter.stage.invalid-opportunity',
			defaultMessage: 'Invalid opportunity',
			description: 'Invalid opportunity stage for a Salesforce opportunity',
		},
	});
